import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[snRemoveAriaOwns]',
  exportAs: 'snRemoveAriaOwns',
})
export class SnRemoveAriaLabelDirective implements AfterViewInit {
  constructor(private readonly _element: ElementRef) {}

  public ngAfterViewInit(): void {
    this.removeAriaOwns();
  }

  public removeAriaOwns(): void {
    const parentElement = this._element.nativeElement.parentElement;

    const labelElement = parentElement.querySelectorAll('label');

    labelElement.forEach((element) => {
      element.removeAttribute('aria-owns');
    });
  }
}
